import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";

import { SignUpWithMicrosoft } from "../SocialSignUp/SignUpWithMicrosoft";
import { GoogleIcon } from "../../icons/google";
import InputEmail from "../../Inputs/InputEmail/InputEmail";
import InputPassword from "../../Inputs/InputPassword/InputPassword";
import ButtonSecondary from "../../buttons/ButtonSecondary/ButtonSecondary";
import { Separator } from "../Separator/Separator";
import { AuthOption, useAuth } from "@/context/AuthContext";
import { isAllTrue } from "@/utils/arrays";
import { initialText, TextState } from "../../Inputs/InputText/InputText";
import styles from "./LoginForm.module.scss";
import { Email } from "@carbon/icons-react";

export const LoginForm = () => {
  const router = useRouter();
  const { setAuthOption, loginWithEmailAndPassword, loginWithGoogle } =
    useAuth();

  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [showEmailLogin, setShowEmailLogin] = useState(false);
  const [email, setEmail] = useState<TextState>(initialText);
  const [password, setPassword] = useState<TextState>(initialText);
  const [formValid, setFormValid] = useState(false);

  const pathname = router.pathname;

  useEffect(() => {
    setFormValid(
      (email.value &&
        isAllTrue(email.validators) &&
        password.value &&
        isAllTrue(password.validators)) ||
        false
    );
  }, [email, password]);

  const handleFormSubmit = (event: any) => {
    event.preventDefault();
    setLoading(true);
    const data = { email: email.value, password: password.value };
    console.log("[LoginForm] Starting email login...");
    loginWithEmailAndPassword(data)
      .then(async () => {
        const authPages = ["/", "/login", "/signup"];
        const url = authPages.includes(pathname) ? "/generator" : pathname;
        await router.push(url);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleGoogleLogin = async () => {
    setGoogleLoading(true);
    loginWithGoogle()
      .then(() => {
        const authPages = ["/", "/login", "/signup"];
        const url = authPages.includes(pathname) ? "/generator" : pathname;
        // Use hard redirect to avoid flash
        window.location.href = url;
      })
      .catch(() => {
        setGoogleLoading(false);
      });
  };

  return (
    <div className={styles.loginContainer}>
      <SignUpWithMicrosoft />
      <div className={styles.minecraftInfo}>
        <p className={styles.infoText}>
          Sign in with your Minecraft account to enable direct skin uploads!
        </p>
      </div>
      <Separator />

      <form>
        {!showEmailLogin ? (
          <div className="flex flex-col gap-3 mb-6">
            <ButtonSecondary
              variant="white"
              size="lg"
              className="w-full"
              loading={googleLoading}
              disabled={googleLoading}
              onClick={handleGoogleLogin}
              text="Continue with Google"
              icon={<GoogleIcon />}
            />
            <ButtonSecondary
              variant="white"
              size="lg"
              className="w-full"
              onClick={() => setShowEmailLogin(true)}
              text="Login with email"
              icon={<Email size={24} />}
            />
          </div>
        ) : (
          <div className={styles.emailLoginForm}>
            <div className="flex flex-col gap-2">
              <InputEmail
                id="inputEmailLogin"
                label={"Email"}
                email={email}
                setEmail={setEmail}
              />

              <InputPassword
                id="inputPasswordLogin"
                password={password}
                setPassword={setPassword}
                disabled={false}
              />
            </div>
            <a
              className={`app-link body-3 white main ${styles.linkForget}`}
              onClick={() => setAuthOption(AuthOption.Reset)}
            >
              Forgot password?
            </a>

            <ButtonSecondary
              size="lg"
              className="w-full mt-8"
              disabled={!formValid}
              loading={loading}
              text={"Sign in"}
              onClick={handleFormSubmit}
            />

            <div className="mt-4">
              <ButtonSecondary
                variant="white"
                size="lg"
                className="w-full"
                loading={googleLoading}
                disabled={googleLoading}
                onClick={handleGoogleLogin}
                text="Continue with Google"
                icon={<GoogleIcon />}
              />
            </div>
          </div>
        )}
      </form>
    </div>
  );
};
